module.exports = __webpack_public_path__ + "media/mixkit-phone-ring-bell-593.26139926.wav";